import React from 'react';
import MuiIconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import { withStyles } from '@material-ui/core/styles';
import { mainColor } from '../../constants';

const IconButton = withStyles({
  root: {
    '&:hover': {
      backgroundColor: `rgba(${mainColor.rgb}, 0.5)`
    },
    padding: '7px 7px 7px 7px'
  }
})(MuiIconButton);

const LightTooltip = withStyles(theme => ({
  tooltip: {
    backgroundColor: theme.palette.common.white,
    color: 'rgba(0, 0, 0, 0.87)',
    boxShadow: theme.shadows[1],
    fontSize: 11
  }
}))(Tooltip);

type IconProps = {
  color?: any,
  onClick?: any,
  className?: string,
  children?: React.ReactNode,
  label?: string,
  size?: 'medium' | 'small',
  title?: string,
  ariaOwns?: any,
  disablePortal?: boolean,
  ariaHaspopup?: any,
  disabled?: boolean,
  style?: React.CSSProperties
}

function Icon({ color = 'default', onClick, className, children, label, size = 'small', title = '', ariaOwns = false, disablePortal = true, ariaHaspopup = true, disabled = false, style = {} }: IconProps) {
  return (
    <LightTooltip PopperProps={{ disablePortal }} title={title}>
      <IconButton
        size={size}
        color={color}
        aria-owns={ariaOwns}
        aria-haspopup={ariaHaspopup}
        className={className}
        style={style}
        aria-label={label}
        disabled={disabled}
        onClick={onClick}
      >
        {children}
      </IconButton>
    </LightTooltip>
  );

}

export default (Icon);